import { type ReactElement } from 'react'
import { CircularProgress } from '@mui/material'
import { SpinnerModalCenter } from './styles'

const SpinnerModalBlock = (): ReactElement<any, any> => {
  return (
    <SpinnerModalCenter>
      <CircularProgress color='primary' />
    </SpinnerModalCenter>
  )
}

export default SpinnerModalBlock
